import { lazy } from 'react'

// Members (banks & organizations)
export const MembersPage = lazy(() => import('@features/members/pages/MembersPage'))
export const BankCreateWizardPage = lazy(() =>
  import('@features/members/pages/BankCreateWizardPage').then((module) => ({
    default: module.BankCreateWizardPage,
  }))
)
export const BankDetailPage = lazy(() =>
  import('@features/members/pages/BankDetailPage').then((module) => ({
    default: module.BankDetailPage,
  }))
)
export const OrganizationCreateWizardPage = lazy(() =>
  import('@features/members/pages/OrganizationCreateWizardPage').then((module) => ({
    default: module.OrganizationCreateWizardPage,
  }))
)
export const OrganizationDetailPage = lazy(() =>
  import('@features/members/pages/OrganizationDetailPage').then((module) => ({
    default: module.OrganizationDetailPage,
  }))
)

// Programs
export const ProgramsPage = lazy(() => import('@features/programs/pages/ProgramsPage'))
export const CardProgramDetailPage = lazy(() => import('@features/programs/pages/CardProgramDetailPage'))
export const ProgramProductDetailPage = lazy(() => import('@features/programs/pages/ProgramProductDetailPage'))

// Money Movement
export const MMBalancePage = lazy(() => import('@features/money-movement/pages/BalancePage'))
export const MMAccountsPage = lazy(() => import('@features/money-movement/pages/AccountsPage'))
export const MMOperationsPage = lazy(() =>
  import('@features/money-movement/pages/OperationsPage')
)
export const MMSystemAccountsPage = lazy(() =>
  import('@features/money-movement/pages/SystemAccountsPage')
)
export const MMAccountDetailPage = lazy(() =>
  import('@features/money-movement/pages/MmAccountDetailPage')
)
export const MMOperationDetailPage = lazy(() =>
  import('@features/money-movement/pages/MmOperationDetailPage')
)
export const MMPayoutDetailPage = lazy(() =>
  import('@features/money-movement/pages/MmPayoutDetailPage')
)
export const MMReserveDetailPage = lazy(() =>
  import('@features/money-movement/pages/MmReserveDetailPage')
)
export const MMDepositDetailPage = lazy(() =>
  import('@features/money-movement/pages/MmDepositDetailPage')
)
export const MMCollectedFeeDetailPage = lazy(() =>
  import('@features/money-movement/pages/MmCollectedFeeDetailPage')
)
export const MMAdjustmentDetailPage = lazy(() =>
  import('@features/money-movement/pages/MmAdjustmentDetailPage')
)

// Rails
export const RailsPage = lazy(() => import('@features/rails/pages/RailsPage'))
export const SettlementListPage = lazy(() => import('@features/settlements/pages/SettlementListPage'))
export const ClearingListPage = lazy(() => import('@shared/components/pages/clearing-list-page'))
export const ReconciliationsListPage = lazy(() =>
  import('@shared/components/pages/reconciliations-list-page')
)
